import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

interface PreviewPanelBodyProps {
	children: React.ReactNode;
}

const styles = cssMap({
	wrapper: {
		flexGrow: 1,
		overflow: 'auto',
	},
});

export const PreviewPanelBody = ({ children }: PreviewPanelBodyProps) => {
	return (
		<Box xcss={styles.wrapper} paddingInlineStart="space.300">
			{children}
		</Box>
	);
};
